export async function registerUploadSW() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    return await navigator.serviceWorker.register("/sw-upload.js", {
      scope: "/",
      type: "module",
    });
  } catch (e) {
    console.warn("project-files SW registration failed:", e);
    return null;
  }
}
